import Vue from 'vue'
import Vuex from 'vuex'
import {
  setStore,
  getStore
} from './utils';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {
    SetAccountInfo(state, accountInfo) {
      Vue.set(state, 'accountInfo', accountInfo)
    }
  },
  actions: {
    SetAccountInfo({
      commit
    }, accountInfo) {
      commit('SetAccountInfo', accountInfo);
    }
  },
  getters: {
    GetAccountInfo: (state) => {
      return state.accountInfo
    },
  }
})